// Run an async task one at a time; a burst collapses to one re-run at the newest arguments.

export function latestOnly(task) {
  let running = false
  let pendingArguments = null

  const run = async (...taskArguments) => {
    if (running) {
      pendingArguments = taskArguments
      return
    }
    running = true
    let current = taskArguments
    try {
      for (;;) {
        await task(...current)
        if (!pendingArguments) return
        current = pendingArguments
        pendingArguments = null
      }
    } finally {
      running = false
      pendingArguments = null
    }
  }

  run.isRunning = () => running
  return run
}
